<template>
  <v-edit-dialog
    class="edit-dialog"
    :style="{ 'border-color': (errorMessages && errorMessages.length) ? 'red': '#e0e0e0' }">
    <div :class="{ 'row-disabled': $attrs.disabled }">
      <v-icon
        v-if="!$attrs.disabled && iconDisabled"
        x-small
        left>
        mdi-pencil
      </v-icon>
      <slot name="text">
        {{ $attrs.value }}
      </slot>
    </div>
    <div
      v-for="(message, index) in errorMessages"
      :key="index"
      class="ml-5 error--text">
      {{ message }}
    </div>
    <template
      v-if="!$attrs.disabled"
      #input>
      <slot>
        <v-text-field
          class="mt-5"
          width="150px"
          counter
          autofocus
          outlined
          dense
          v-bind="$attrs"
          v-on="$listeners" />
      </slot>
    </template>
  </v-edit-dialog>
</template>

<script>
export default {
  name: 'EditDialog',
  props: {
    iconDisabled: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
  },
}
</script>

<style scoped>
.edit-dialog {
  border-bottom: 1px solid #e0e0e0;
}
.row-disabled {
  opacity: 80%;
}
</style>
